export default "__VITE_ASSET__ML2sVRle__"